import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollTo, scrollToTop as smoothScrollToTop } from "./smoothScroll";

const scrollToTop = () => {
  smoothScrollToTop(true);
};

const ScrollManager = () => {
  const { pathname, hash, key } = useLocation();

  useLayoutEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (hash) {
      const id = decodeURIComponent(hash.replace("#", ""));
      let cancelled = false;
      let frames = 0;

      const tryScroll = () => {
        if (cancelled) return;
        const el = document.getElementById(id);
        if (el) {
          // Lenis glides to the section; fall back to native smooth scroll
          // when it is inactive (reduced motion / not initialised yet).
          if (!scrollTo(el, { duration: 1.2 })) {
            el.scrollIntoView({ behavior: "smooth" });
          }
          return;
        }
        frames += 1;
        if (frames < 90) {
          requestAnimationFrame(tryScroll);
        }
      };

      requestAnimationFrame(tryScroll);
      return () => {
        cancelled = true;
      };
    }

    scrollToTop();
    const frame = requestAnimationFrame(scrollToTop);
    const timeout = setTimeout(scrollToTop, 350);
    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
    };
  }, [pathname, hash, key]);

  return null;
};

export default ScrollManager;
